import React from "react";
import ImgAbout from "../static/img/java.png";
import { Fade } from "react-reveal";


export default class Skills extends React.Component {
  render() {
    return (
      
      <Fade right duration={1000} distance="20px">
      
      <div className="container about-me remove-padding d-flex flex-column flex-lg-row">
        <div className="about-left-side m-4 col-lg-6 about-me-texts uiux">
          <br></br>
          <span className="txt-about">Skills</span>
          <br></br>
          <br></br>

          <p>

            <strong>  Frontend : </strong>   React - Angular - HTML - CSS -
              Bootstrap - UIkit - Jquery{" "}
          </p>
          <p>

            <strong>  Backend: </strong>Django , Flask , Ionic ,
              ReactNative , Android , JEE , Spring , Laravel , ElectronJS , ..
            </p>

          <p>

            <strong>  Programming Languages : </strong> Java , Javascript,
              Typescript , C# , PHP , Python{" "}
          </p>

          <p>

            <strong>  Databasse administration : </strong> MongoDB , sqlite ,
              SQL /NOSQL , Oracle , Myphpadmin, Firebase , GraphQL{" "}
          </p>
          <p>

            <strong>  IDE : </strong> Pycharm , webStorm , Atom , Netbeans ,
              Eclipse , Vscode , Visual studio ,Android Studio , Brackets ..{" "}
          </p>
          <p>

            <strong>  Tools : </strong> Git , Bitbukets , Heroku , Docker ,
              Postman , Trello , StarUML , PowerAMC ,  Prestashop ,
              Wordpress, Odoo , Dolibarr ..{" "}
          </p>



        </div>
        <div className=" m-4">
          <div className="about-me-texts">
          <img
              alt="skills"
              src={ImgAbout}
              width="500" height="370" 
              />
          </div>
          {/*<div className="about-btn-container mt-5 d-flex flex-column flex-sm-row align-items-center">*/}
          {/*<span className="btn-rounded m-2 col-6 text-center">hire me</span>*/}
          {/*<span className="btn-none-rounded m-2 col-6 text-center">see my resume</span>*/}
          {/*</div>*/}
        </div>
      </div>
 <br></br>
      </Fade>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Skills.js